import ApiClient from '../../../helpers/apiClient';
import { startSubmit } from 'redux-form';
import id from 'date-fns/locale/id/index';

export const FETCH_COUPON_AUTOMATION_REQUEST = 'FETCH_COUPON_AUTOMATION_REQUEST';
export const FETCH_COUPON_AUTOMATION_SUCCESS = 'FETCH_COUPON_AUTOMATION_SUCCESS';
export const FETCH_COUPON_AUTOMATION_ERROR = 'FETCH_COUPON_AUTOMATION_ERROR';

export const FETCH_COUPON_AUTOMATION_DETAIL_REQUEST = 'FETCH_COUPON_AUTOMATION_DETAIL_REQUEST';
export const FETCH_COUPON_AUTOMATION_DETAIL_SUCCESS = 'FETCH_COUPON_AUTOMATION_DETAIL_SUCCESS';
export const FETCH_COUPON_AUTOMATION_DETAIL_ERROR = 'FETCH_COUPON_AUTOMATION_DETAIL_ERROR';

export const GET_COUPON_AUTOMATION_DETAIL_REQUEST = 'GET_COUPON_AUTOMATION_DETAIL_REQUEST';
export const GET_COUPON_AUTOMATION_DETAIL_SUCCESS = 'GET_COUPON_AUTOMATION_DETAIL_SUCCESS';
export const GET_COUPON_AUTOMATION_DETAIL_ERROR = 'GET_COUPON_AUTOMATION_DETAIL_ERROR';

export const CREATE_COUPON_AUTOMATION_REQUEST = 'CREATE_COUPON_AUTOMATION_REQUEST';
export const CREATE_COUPON_AUTOMATION_SUCCESS = 'CREATE_COUPON_AUTOMATION_SUCCESS';
export const CREATE_COUPON_AUTOMATION_ERROR = 'CREATE_COUPON_AUTOMATION_ERROR';

export const UPDATE_COUPON_AUTOMATION_REQUEST = 'UPDATE_COUPON_AUTOMATION_REQUEST';
export const UPDATE_COUPON_AUTOMATION_SUCCESS = 'UPDATE_COUPON_AUTOMATION_SUCCESS';
export const UPDATE_COUPON_AUTOMATION_ERROR = 'UPDATE_COUPON_AUTOMATION_ERROR';

export const DELETE_COUPON_AUTOMATION_REQUEST = 'DELETE_COUPON_AUTOMATION_REQUEST';
export const DELETE_COUPON_AUTOMATION_SUCCESS = 'DELETE_COUPON_AUTOMATION_SUCCESS';
export const DELETE_COUPON_AUTOMATION_ERROR = 'DELETE_COUPON_AUTOMATION_ERROR';

export const FETCH_COUPON_OPTIONS_REQUEST =
    'FETCH_COUPON_OPTIONS_REQUEST';
export const FETCH_COUPON_OPTIONS_SUCCESS =
    'FETCH_COUPON_OPTIONS_SUCCESS';
export const FETCH_COUPON_OPTIONS_ERROR =
    'FETCH_COUPON_OPTIONS_ERROR';

export const fetchCouponAutomation = data => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [FETCH_COUPON_AUTOMATION_REQUEST, FETCH_COUPON_AUTOMATION_SUCCESS, FETCH_COUPON_AUTOMATION_ERROR],
            callAPI: () => ApiClient.post('payment/CouponAutomation/Search', data),
            payload: { data },
        }),
    );
};

export const createCouponAutomation = (data, formId) => dispatch => {
    return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
        dispatch({
            types: [CREATE_COUPON_AUTOMATION_REQUEST, CREATE_COUPON_AUTOMATION_SUCCESS, CREATE_COUPON_AUTOMATION_ERROR],
            callAPI: () => ApiClient.post('payment/CouponAutomation', data),
            payload: { data, formId },
        }),
    );
};

export const updateCouponAutomation = (id, data, formId) => dispatch => {
    return Promise.resolve(dispatch(startSubmit(formId))).then(() =>
        dispatch({
            types: [UPDATE_COUPON_AUTOMATION_REQUEST, UPDATE_COUPON_AUTOMATION_SUCCESS, UPDATE_COUPON_AUTOMATION_ERROR],
            callAPI: () => ApiClient.put(`payment/CouponAutomation/${id}`, data),
            payload: { data: { ...data, id }, formId },
        }),
    );
};

export const getCouponAutomationDetail = id => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [GET_COUPON_AUTOMATION_DETAIL_REQUEST, GET_COUPON_AUTOMATION_DETAIL_SUCCESS, GET_COUPON_AUTOMATION_DETAIL_ERROR],
            callAPI: () => ApiClient.get(`payment/CouponAutomation/${id}`),
            payload: { data: { id } },
        }),
    );
};

export const fetchCouponAutomationOptions = () => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [
                FETCH_COUPON_OPTIONS_REQUEST,
                FETCH_COUPON_OPTIONS_SUCCESS,
                FETCH_COUPON_OPTIONS_ERROR,
            ],
            callAPI: () => ApiClient.get('payment/CouponAutomation/GetSelectList'),
            payload: {},
        }),
    );
};

export const deleteCouponAutomation = id => dispatch => {
    return Promise.resolve().then(() =>
        dispatch({
            types: [DELETE_COUPON_AUTOMATION_REQUEST, DELETE_COUPON_AUTOMATION_SUCCESS, DELETE_COUPON_AUTOMATION_ERROR],
            callAPI: () => ApiClient.delete(`payment/CouponAutomation/${id}`),
            payload: { data: { id } },
        }),
    );
};

const initialState = {
    payload: {},
    data: {},
    response: {},
    error: {},
    errorMessage: '',
    successMessage: '',
};

export default function reducer(state = initialState, action) {
    const { payload, response, error, successMessage, errorMessage } = action;
    switch (action.type) {
        case FETCH_COUPON_AUTOMATION_REQUEST:
        case FETCH_COUPON_OPTIONS_REQUEST:
            return {
                ...state,
                payload,
                response: {},
                error: {},
                successMessage: '',
                errorMessage: '',
            };


        case FETCH_COUPON_AUTOMATION_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    items: response.data.data.items,
                    pages: response.data.data.pageCount,
                },
                response,
                successMessage,
            };

        case FETCH_COUPON_OPTIONS_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    options: response.data.data,
                },
                response,
                successMessage,
            };

        case GET_COUPON_AUTOMATION_DETAIL_SUCCESS:
            return {
                ...state,
                data: {
                    ...state.data,
                    item: response.data.data,
                },
                response,
                successMessage,
            };

        case CREATE_COUPON_AUTOMATION_SUCCESS:
        case UPDATE_COUPON_AUTOMATION_SUCCESS:
        case DELETE_COUPON_AUTOMATION_SUCCESS:
            return {
                ...state,
                response,
                successMessage,
            };

        case FETCH_COUPON_AUTOMATION_ERROR:
        case CREATE_COUPON_AUTOMATION_ERROR:
        case UPDATE_COUPON_AUTOMATION_ERROR:
        case FETCH_COUPON_OPTIONS_ERROR:
        case DELETE_COUPON_AUTOMATION_ERROR:
            return {
                ...state,
                payload,
                error,
                errorMessage,
            };
        default:
            return state;
    }
}
